import { NgModule } from 'ng-metadata/core';
import { SlugifyPipe } from './slug.pipe';
import { CountryPipe } from './country.pipe';

/**
 * Pipes Module
 */
@NgModule({
  providers: [
    CountryPipe,
    SlugifyPipe,
  ],
})
export class PipesModule {}



// WEBPACK FOOTER //
// ./resources/assets/js/pipes/index.ts